import {Box, Button, Checkbox, CircularProgress, FormControlLabel, useMediaQuery, useTheme} from "@mui/material";
import {useRef, useState} from "react";
import axios from "axios";

function Photo() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [isPrivacyAccepted, setIsPrivacyAccepted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    const [fileUrl, setFileUrl] = useState(null);

    const restart = () => {
        fileInputRef.current.value = '';
        setSelectedFile(null);
        setSuccess(false);
        setIsPrivacyAccepted(false);
    }

    const handleCheckboxChange = (e) => {
        setIsPrivacyAccepted(e.target.checked);
    };

    // Al click di CREA, apri la fotocamera/selettore file (solo se la privacy è accettata)
    const handleClickCrea = () => {
        if (isPrivacyAccepted && fileInputRef.current) {
            //setError(false);
            fileInputRef.current.value = '';
            fileInputRef.current.click();
        }
    };

    // Gestisce la selezione del file e fa l’upload via POST
    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                'https://alleanza-photo-filter-574969884775.europe-west1.run.app/images/upload',
                formData
            );
            setSuccess(true);
            setFileUrl(response.data.fileUrl);
            console.info('Upload riuscito:', response.data);
        } catch (error) {
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    const downloadFile = async (url, fileName = 'foto_personalizzata.jpg') => {
        try {
            // Richiedi il file come Blob
            const response = await axios.get(url, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            // Verifica se il dispositivo supporta `navigator.msSaveBlob` (per vecchi browser e mobile)
            if (window.navigator && window.navigator.msSaveBlob) {
                // Download per dispositivi che supportano msSaveBlob (e.g., vecchi browser Microsoft)
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                // Per browser moderni
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Libera memoria
                URL.revokeObjectURL(blobUrl);
            }
        } catch (error) {
            console.error('Errore durante il download del file:', error);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100vw',
                height: '100vh',
                margin: 0,
                padding: 0,
            }}
        >
            <header style={{flex: '0 0 auto'}}>
                <img
                    src={isMobile ? "/assets/header.jpg" : "/assets/header-desktop.jpg"}
                    alt="Header"
                    style={{width: '100%', display: 'block'}}
                />
            </header>

            {/* Contenuto centrale dinamico (scrollabile se serve) */}
            {!loading &&
                <main style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1 0 auto',
                    overflowY: 'auto',
                    textAlign: 'center',
                    margin: 'auto'
                }}>
                    {success ?
                        <>
                            <h3 style={{color: '#ea592a', fontWeight: 'bold', marginBottom:0, marginTop:isMobile ? 0 : '16px'}}>ECCO LA TUA FOTO DA PROTAGONISTA!</h3>
                            <p style={{color: '#004b87', fontWeight: 'bold', padding: '16px', paddingTop: '0px', paddingBottom:0}}>
                                Aggiorna le immagini dei tuoi profili social. <br/>
                            </p>
                            <Box sx={{width:isMobile ? '60vw' :'30vw'}}>
                                <img src={fileUrl} alt={'foto modificata'} style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain'
                                }}/>
                            </Box>
                            <Button
                                disabled={!isPrivacyAccepted}
                                variant="contained"
                                sx={{
                                    fontSize: '20px',
                                    backgroundColor: '#e95928',
                                    color: '#fff',
                                    '&:hover': {
                                        backgroundColor: '#d0481f', // Colore leggermente più scuro in hover
                                    },
                                    width:isMobile ? '60vw' :'30vw',
                                    marginTop: '16px',
                                    marginBottom: isMobile ? 0 : '16px'
                                }}
                                onClick={() => downloadFile(fileUrl)}

                            >
                                DOWNLOAD
                            </Button>

                            <p>
                                <span style={{color: '#fff', background:'#024981'}}> #SQUADRAALLEANZA </span>  <span style={{color: '#fff', background:'#024981', marginLeft:'16px'}}> #PENSAREINGRANDE </span>
                            </p>

                            <p style={{color: '#ea592a', fontWeight: '700', textDecoration:'underline'}}
                            onClick={restart}>
                                Realizza un'altra foto
                            </p>

                        </>
                        :
                        <>
                            <h3 style={{color: '#ea592a', fontWeight: '700 !important'}}>CREA LA TUA FOTO
                                PERSONALIZZATA!</h3>
                            <p style={{color: '#004b87', fontWeight: 'bold', padding: '16px', paddingTop: '0px'}}>
                                Scatta o carica la tua foto, <br/>
                                clicca per applicare il filtro dedicato alla Convention. <br/>
                            </p>

                            <Button
                                disabled={!isPrivacyAccepted}
                                variant="contained"
                                sx={{
                                    fontSize: '20px',
                                    backgroundColor: '#e95928',
                                    color: '#fff',
                                    '&:hover': {
                                        backgroundColor: '#d0481f', // Colore leggermente più scuro in hover
                                    },
                                    width: isMobile ? '40vw' : '20vw',
                                    marginBottom: '16px'
                                }}
                                onClick={handleClickCrea}
                            >
                                CREA
                            </Button>

                            <h5 style={{
                                paddingLeft: '16px',
                                paddingRight: '16px',
                                color: '#a54741',
                                marginTop: 0,
                                marginBottom: 0
                            }}>
                                {error &&
                                    "C'è stato un errore durante il caricamento della foto, per favore riprova."
                                }

                            </h5>

                            <h4 style={{color: '#004b87', fontWeight: 'bold', marginBottom: 0}}><a
                                style={{color: '#004b87', fontWeight: 'bold', marginBottom: 0, textDecoration: 'none'}}
                                href={'/informativa-privacy.pdf'} target={'_blank'}>INFORMATIVA PRIVACY</a></h4>
                            <Box p={'16px'} paddingTop={'0px'}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isPrivacyAccepted}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="Privacy: Dichiaro di accettare i termini e le condizioni"
                                    sx={{
                                        '.MuiFormControlLabel-label': {
                                            color: '#004b87',
                                            textAlign: 'left'
                                        },
                                    }}
                                />
                            </Box>
                        </>

                    }
                </main>
            }

            {loading &&
                <main style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1 0 auto',
                    overflowY: 'auto',
                    textAlign: 'center',
                    margin: 'auto',
                    height: !isMobile ? '360px' : 'auto'
                }}>
                    <CircularProgress/>
                </main>
            }


            <footer style={{flex: '0 0 auto'}}>
                <img
                    src="/assets/footer.jpg"
                    alt="Footer"
                    style={{width: '100%', display: 'block'}}
                />
            </footer>

            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                //capture="user"
                style={{display: 'none'}}
                onChange={handleFileChange}
            />
        </div>
    );
}

export default Photo;
